import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import React, { useRef, useEffect } from "react";
import "./index.scss";
import { debounce } from "./util/debounce";

function App() {
  // 区域组件ref + 导航组件ref
  const sectionCompRef = useRef(null);
  const smenuCompRef = useRef(null);
  // 存储 Intersection Observer 实例
  const observerRef = useRef(null);

  useEffect(() => {
    const sectionRefs = sectionCompRef.current?.sectionRefs;
    const menuRefs = smenuCompRef.current?.menuRefs;
    if (!sectionRefs || !menuRefs) return;

    // 1. 创建 Intersection Observer 实例
    observerRef.current = new IntersectionObserver(
      (entries) => {
        // 2. 遍历所有被观察的区域
        entries.forEach((entry) => {
          const sectionKey = entry.target.dataset.key; // 获取区域对应的key（home/about等）
          const targetMenu = menuRefs[sectionKey]?.current;
          if (!targetMenu) return;

          // 3. 根据交集状态添加/移除active类
          if (entry.isIntersecting) {
            // 先移除所有菜单的active
            Object.values(menuRefs).forEach((menu) =>
              menu.current?.classList.remove("active")
            );
            // 给当前区域对应菜单添加active
            targetMenu.classList.add("active");
          }
        });
      },
      {
        threshold: 0.5, // 区域进入可视区50%时触发
        rootMargin: "0px", // 可视区边缘的偏移量（可选）
      }
    );

    // 4. 批量监听所有区域元素
    Object.entries(sectionRefs).forEach(([key, sectionRef]) => {
      const section = sectionRef.current;
      if (section) {
        section.dataset.key = key; // 给元素添加key标识，用于匹配菜单
        observerRef.current.observe(section);
      }
    });

    // 组件卸载时销毁实例
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);
  // 1. 定义移动端判断和样式更新函数
  const handleWindowResize = () => {
    const isMobile = window.innerWidth <= 768;
    console.log("isMobile:", isMobile);
    if (isMobile) {
      document.body.classList.add("mobile-view");
    } else {
      document.body.classList.remove("mobile-view");
    }
  };

  const debouncedUpdateBodyClass = debounce(handleWindowResize, 200);
  useEffect(() => {
    // 初始化执行
    handleWindowResize();
    // 添加窗口监听
    window.addEventListener("resize", debouncedUpdateBodyClass);
    // 组件卸载时移除监听（清理副作用）
    return () => {
      window.addEventListener("resize", debouncedUpdateBodyClass);
    };
  }, []); // 空依赖数组，仅在组件挂载/卸载时执行
  return (
    <Router>
      <Navbar ref={smenuCompRef} />
      <Routes>
        <Route path='/' element={<Home ref={sectionCompRef} />} />
      </Routes>
    </Router>
  );
}

export default App;
